import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=6f637053&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=js&"
export * from "./UserCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=6f637053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f637053",
  null
  
)

export default component.exports